
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VArea from 'vux/src/components/v-chart/v-area.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLegend from 'vux/src/components/v-chart/v-legend.vue'
import VBar from 'vux/src/components/v-chart/v-bar.vue'
import VPie from 'vux/src/components/v-chart/v-pie.vue'
import VGuide from 'vux/src/components/v-chart/v-guide.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'

import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import XDialog from 'vux/src/components/x-dialog/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import Icon from 'vux/src/components/icon/index.vue'

import { setTimeout } from 'timers';
import Alert from 'vux/src/components/alert/index.vue'

import Toast from 'vux/src/components/toast/index.vue'

import XTextarea from 'vux/src/components/x-textarea/index.vue'

import dateFormat from 'vux/src/tools/date/format.js'
import base64 from 'vux/src/tools/base64/index.js'

import Cookies from "js-cookie";
import { resolveMediaUrl } from '@/utils/mediaUrl'
import newApi from '@/utils/newModuleApi'
import { buildMeanAndExampleHtml } from '@/utils/wordHighlight'
const map = {}
export default {
directives: {
TransferDom
},
filters: {
dateFormat
},
components: {
XInput,
XButton,
Group,
Cell,
VChart,
VLine,
VArea,
VTooltip,
VLegend,
VBar,
VPie,
VGuide,
VScale,
XHeader,
Divider,
Flexbox,
FlexboxItem,
Swiper,
SwiperItem,
Alert,
Toast,
XDialog,
XTextarea,
Icon
},
data() {
return {
highlightStyle: `
position: relative;
color: #212121;
background: #fff3b0;
padding: 2px 5px;
border-radius: 4px;
`,
prevIndex: null, // 新增：记录前一个索引
message: {},
wsongUrl: '',
wordList: [],
index: 0,
show: true,
isStarred: false,
flag: false,
list: [],
showDeil: true,
height: '0px',
position: 'middle',
showPositionValue: false,
total: 0,
pageNo: 1,
type: '',
name: '',
count: 0,
toastText: '进行下一阶段',
showToast: false,
showVideo: false,
showVideoFlag: false,
saveFeedBackSuccess: false,
saveFeedBackError: false,
feedback: '',
loadedImages: new Set(),
audio: {
currentTime: 0,
maxTime: 0,
playing: false,
muted: false,
speed: 1,
waiting: true,
preload: 'auto'
},
controlList: {

noDownload: true,

noMuted: true,

noVolume: false,

noProcess: false,

onlyOnePlaying: false,

noSpeed: true
},
wordinfo: {
word: '',
yvideo: '',
mvideo: ''
},
detailedWord: {

},
exchange: [],
isWordPower:null,
wordNavigateStack: [],
playingAccent: '',
_switchingAudio: false
}
},

computed: {
navTitle () {
const total = (this.wordList && this.wordList.length) || 0
if (!total) return '单词斩'
return `第 ${this.index + 1} / ${total} 个单词`
},

changeIndex(position, newValue) {
this.$set(this.customIndices, position, newValue);
},
processedMean () {
if (!this.detailedWord || !this.detailedWord.mean) return ''
return buildMeanAndExampleHtml(this.detailedWord.mean, this.detailedWord.example, { style: this.highlightStyle }).processedMean
},
processedExample() {
if (!this.detailedWord || !this.detailedWord.mean || !this.detailedWord.example) {
return this.detailedWord.example || '';
}
return buildMeanAndExampleHtml(this.detailedWord.mean, this.detailedWord.example, { style: this.highlightStyle }).processedExample
},
processedWordSplit() {
if (!this.detailedWord || !this.detailedWord.wordSplit) {
return '';
}
const raw = String(this.detailedWord.wordSplit).replace(/<[^>]+>/g, '');
const plusStyle = this.wordPartPlusStyle();
const chipStyle = this.wordPartChipStyle(false);
return raw.split('+')
.map(function (p) { return p.trim(); })
.filter(Boolean)
.map(part => '<span class="word-part" style="' + chipStyle + '">' + this.escapeHtml(part) + '</span>')
.join('<span class="word-part-plus" style="' + plusStyle + '">+</span>');
},
processedWordIde() {
if (!this.detailedWord || !this.detailedWord.wordIde) {
return '';
}
const raw = String(this.detailedWord.wordIde).replace(/<[^>]+>/g, '');
const plusStyle = this.wordPartPlusStyle();
const that = this;
return raw.split(/\s*\+\s*/)
.map(function (seg) { return that.formatIdeSegment(seg); })
.join('<span class="word-part-plus" style="' + plusStyle + '">+</span>');
}
},
created() {

let cellIndex = Cookies.get('cellIndex');

if(cellIndex!=null){
this.index =  parseInt(cellIndex);
Cookies.remove('cellIndex');
}
this.type = this.$route.query.type
this.isWordPower = this.$route.query.isWordPower




this.loadData(this.type, true);


var date = dateFormat(new Date(), 'YYYY-MM-DD');
},
async  mounted() {
await this.fetchData();
this.lockPageScroll();
},
beforeDestroy() {
this.unlockPageScroll();
},








methods: {






fetchData(){
var that = this;
this.$store.state.isShowBarKey = false;
$(".feedbackCard").click(function () {
$(this).toggleClass("feedbackActive");
});
this.$nextTick(function () {
const vh = document.documentElement.clientHeight || window.innerHeight;
if (that.$refs.swiper && that.$refs.swiper.xheight !== undefined) {
that.$refs.swiper.xheight = (vh - 46 - 50) + "px";
}
});

},
lockPageScroll() {
const viewBoxBody = document.getElementById('vux_view_box_body');
if (viewBoxBody) {
this._prevViewBoxOverflow = viewBoxBody.style.overflow;
this._prevViewBoxHeight = viewBoxBody.style.height;
viewBoxBody.style.overflow = 'hidden';
viewBoxBody.style.height = '100%';
}
const routerView = this.$el && this.$el.parentElement;
if (routerView && routerView.classList.contains('router-view')) {
this._prevRouterOverflow = routerView.style.overflow;
this._prevRouterHeight = routerView.style.height;
routerView.style.overflow = 'hidden';
routerView.style.height = '100%';
}
},
unlockPageScroll() {
const viewBoxBody = document.getElementById('vux_view_box_body');
if (viewBoxBody) {
viewBoxBody.style.overflow = this._prevViewBoxOverflow || '';
viewBoxBody.style.height = this._prevViewBoxHeight || '';
}
const routerView = this.$el && this.$el.parentElement;
if (routerView && routerView.classList.contains('router-view')) {
routerView.style.overflow = this._prevRouterOverflow || '';
routerView.style.height = this._prevRouterHeight || '';
}
},
escapeHtml(unsafe) {
return unsafe.replace(/[&<"'>]/g, function (match) {
return {
'&': '&amp;',
'<': '&lt;',
'>': '&gt;',
'"': '&quot;',
"'": '&#39;'
}[match];
});
},

extractKeywords(meanText) {

const cleanedText = meanText.replace(/^.*?\s/, '').replace(/[^\u4e00-\u9fa5]+/g, ' ');

return [...new Set(cleanedText.split(/\s+/).filter(word => word.trim()))];
},


escapeRegExp(text) {
return text
.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
.replace(/</g, '&lt;')
.replace(/>/g, '&gt;');
},
wordPartChipStyle(isLink) {
var base = 'display:inline-block;font-weight:600;line-height:1.35;margin:0 1px;border-radius:4px;vertical-align:baseline;';
if (isLink) {
return base + 'color:#1989fa;background:#eef5ff;border:1px solid rgba(25,137,250,0.45);cursor:pointer;text-decoration:underline;text-underline-offset:2px;text-decoration-thickness:1px;';
}
return base + 'color:#555;background:#f4f7fb;border:1px solid #dde4ec;';
},
wordPartPlusStyle() {
return 'color:#b0bac5;font-weight:500;margin:0 3px;';
},
formatIdeSegment(segment) {
var trimmed = segment.trim();

var match = trimmed.match(/^(\w+)((?:[(（][^)）]+[)）]).*|(?:英文|拼音|象形|形象|音标|词根|口诀).*)$/);
if (!match) {
return this.escapeHtml(trimmed);
}
var word = match[1];
var rest = match[2];
var isEnglish = /^(?:[(（]英文[)）]|英文)/.test(rest);
var escapedWord = this.escapeHtml(word);
var chip = isEnglish
? '<span class="word-part word-part--link word-ide-link" style="' + this.wordPartChipStyle(true) + '" data-word="' + escapedWord + '">' + escapedWord + '</span>'
: '<span class="word-part" style="' + this.wordPartChipStyle(false) + '">' + escapedWord + '</span>';
return chip + this.escapeHtml(rest);
},
showDetail(english,chinese){
Cookies.set("cellIndex",  this.index, { expires: 6000 });

this.$router.push({path:'/indexSelect_display', query:{word:chinese,jumPtOtype:'back'}});
},
onWordIdeClick(e) {
const link = e.target.closest('.word-part--link');
if (link && link.dataset.word) {
e.preventDefault();
this.jumpToEnglishWord(link.dataset.word);
}
},
saveWordNavigateState() {
this.wordNavigateStack.push({
detailedWord: { ...this.detailedWord },
wordinfo: { ...this.wordinfo },
index: this.index,
exchange: [...this.exchange]
});
},
restoreWordNavigateState() {
const prev = this.wordNavigateStack.pop();
if (!prev) return false;
this.detailedWord = prev.detailedWord;
this.wordinfo = prev.wordinfo;
this.index = prev.index;
this.exchange = prev.exchange;
return true;
},
clearWordNavigateStack() {
this.wordNavigateStack = [];
},
jumpToEnglishWord(englishWord) {
const that = this;
this.saveWordNavigateState();
this.$ajax.get(this.$api.messageMessageBoardgetByWord + "?word=" + encodeURIComponent(englishWord) + "&type=back").then(response => {
if (response && response.length > 0) {
that.getWordByid(response[0].id, response[0].wordId);
} else {
that.restoreWordNavigateState();
that.toastText = '未找到单词「' + englishWord + '」';
that.showPositionValue = true;
}
}, () => {
that.restoreWordNavigateState();
that.toastText = '加载单词失败，请稍后重试';
that.showPositionValue = true;
});
},
goReturn() {
if (this.wordNavigateStack.length > 0) {
this.restoreWordNavigateState();
return;
}
if (this.type == 2) {
this.$router.push({ path: '/pmsUnitCellList_display', query: this.$route.query });
} else {
this.$router.push({ path: '/pmsCellList_display', query: this.$route.query });
}
},

loadListData: function (id) {
let that = this;
this.$ajax.get(this.$api.getWordByUnId + "?unid=" + id).then(response => {
that.$vux.loading.hide();
this.wordList = response
this.index =   this.wordList.findIndex(item=>item.id==this.$route.query.querywordId)
this.wordinfo = this.wordList[this.index ]
this.getWordByid(this.wordinfo.id,this.wordinfo.wordId)
}, response => {

that.$vux.loading.hide(); 
});


},
toggleStarWord () {
const wordId = this.detailedWord && this.detailedWord.id
if (!wordId) return
const next = !this.isStarred
this.$ajax.post(newApi.reviewToggleStar, { word_id: wordId, is_star: next }).then(() => {
this.isStarred = next
this.toastText = next ? '已标为重点单词' : '已取消重点'
this.showPositionValue = true
}).catch(() => {
this.toastText = '操作失败'
this.showPositionValue = true
})
},
loadWordStarStatus (wordId) {
if (!wordId) {
this.isStarred = false
return
}
this.$ajax.get(newApi.reviewWordStar + '?word_id=' + wordId).then(res => {
this.isStarred = !!(res && res.is_star)
}).catch(() => {
this.isStarred = false
})
},
closePopup: function () {

},
closeVideo: function () {
this.showVideo = false;
$("#videoTemp").empty();
this.player.dispose();
},
showVideoBtn: function (url) {


this.showVideo = true;
$("#videoTemp").append('<video id="my-player" class="video-js" controls preload="auto"  data-setup="{}"> <source src="' + url + '" type="video/mp4"></source></video>');
this.player = videojs('my-player', {}, function () {
this.on('fullscreenchange', function (event) {
if (!this.showVideoFlag) {
screen.orientation.lock('landscape');
this.showVideoFlag = true;
} else {
screen.orientation.lock("portrait");
this.showVideoFlag = false;
}
})
});
this.player.play();
},
getWordByid: function (wordId,unitWordId) {
this.exchange = []
this.isStarred = false
this.detailedWord = { ...this.detailedWord, pmsImg: null };
this.$ajax.get(this.$api.getPmsPmsWordsById + "?pkId=" + wordId).then(response => {
this.detailedWord = response;
this.loadWordStarStatus(this.detailedWord && this.detailedWord.id)
if( this.detailedWord.pmsImg!=null){
this.detailedWord.pmsImg = resolveMediaUrl(this.detailedWord.pmsImg)
}
if (this.detailedWord.express != null && this.detailedWord.express != '') {
let exchangedata = JSON.parse(this.detailedWord.express);
for (let key in exchangedata) {
let obj = {};
let wordState = '';
if (key == "word_third") {
wordState = "第三人称单数"
} else if (key == "word_name") {
wordState = "原文query"
} else if (key == "word_means") {
wordState = "单词含义，数组"
} else if (key == "exchange") {
wordState = "不同时态"
} else if (key == "word_done") {
wordState = "过去式"
} else if (key == "word_pl") {
wordState = "复数"
} else if (key == "word_past") {
wordState = "过去分词"
} else if (key == "word_ing") {
wordState = "现在分词"
} else if (key == "word_er") {
wordState = "比较级"
} else if (key == "word_proto") {
wordState = "原型"
} else if (key == "word_est") {
wordState = "最高级"
} else {
wordState = key
}

obj.wordct = wordState
obj.word = exchangedata[key]
this.exchange.push(obj)

}
}
this.$ajax.post(this.$api.getPmsPmsStudyAdd, {
wordId: wordId,
wordUnitId: this.$route.query.value,
categoryId: this.$route.query.categoryId || this.$route.query.value
}).then(
(response) => {
},
(response) => {

that.$vux.loading.hide(); 
}
);


}, response => {

that.$vux.loading.hide(); 
});
},

closeDialog: function () {
this.showToast = false;
$(".feedbackActive").removeClass("feedbackActive");
this.feedback = "";
},
goBack: function () {
this.$router.push({ path: '/home?hideTrans=true' })
},
saveFeedBack: function () {
var that = this;
var key = "";
$(".feedbackActive").each(function (index, item) {
key = key + $(item).attr("id") + ",";
});
if (this.message.content.length == 0) {
this.$vux.toast.text('请输入建议', 2000);
return;
}
that.$vux.loading.show({
text: '加载中...'
});






this.$ajax.post(this.$api.messageMessageBoardAdd, this.message).then(result => {
that.$vux.loading.hide(); 
that.saveFeedBackSuccess = true;
that.showToast = false;
$(".feedbackActive").removeClass("feedbackActive");
that.feedback = "";
})















},
showDialog: function () {

this.showToast = true;
$("#feedback").find("textarea").focus();
},
forId: function (index) {
return "my-player" + index
},
loadData: function (id, first) {
let that = this;



this.$ajax.post(this.$api.getUnitListByTotalId, { totalId: this.$route.query.id }).then(result => {
this.wordList = result

this.$ajax.get(this.$api.getStudyByUnitId + "?unitId=" + that.$route.query.value).then(response => {
this.index =   this.wordList.findIndex(item=>item.id==response)
if(this.index == -1){
this.index = 0;
}else{
if( this.type==1){
this.$toast("已跳转到当前学习到的单词");
}

}
this.wordinfo = this.wordList[this.index]
this.getWordByid(this.wordinfo.id,this.wordinfo.wordId)
})
})

this.$ajax.get(this.$api.pmsWordDetail + "?id=5").then(response => {

this.word = response.mean
this.yvideo = response.yinbiao
this.mvideo = response.yinbiao

}, response => {

that.$vux.loading.hide(); 
});
},
onError() {
this.audio.waiting = true

},

onWaiting(res) {

},

onPlay(res) {
this.audio.playing = true
this.audio.loading = false
if (!this.controlList.onlyOnePlaying) {
return
}
const target = res.target
const audios = document.getElementsByTagName('audio');
[...audios].forEach((item) => {
if (item !== target) {
item.pause()
}
})
},
onAudioStop () {
if (this._switchingAudio) return
this.audio.playing = false
this.playingAccent = ''
},
onSwipeChange(newIndex) {

if (this.prevIndex !== null && this.prevIndex !== newIndex) {
this.cleanupPreviousImages(this.prevIndex);
}
this.prevIndex = newIndex;

const currentWord = this.wordList[newIndex];
this.getWordByid(currentWord.id, currentWord.wordId);




},
cleanupPreviousImages(index) {

const prevWord = this.wordList[index];
if (prevWord) {
prevWord.pmsImg = null;
URL.revokeObjectURL(prevWord.pmsImg); 
}


const swiper = this.$refs.swiper.$el;
swiper.querySelectorAll(`img[data-index="${index}"]`).forEach(img => {
img.src = '';
img.remove();
});


this.loadedImages.delete(index);
},


onTimeupdate(res) {
this.audio.currentTime = res.target.currentTime
this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)
const _this = this
},


onLoadedmetadata(res) {
this.audio.waiting = false
this.audio.maxTime = parseInt(res.target.duration)
},

playA: function (english, accent) {
if (!english) return
const el = this.$refs.waudio || ($("#waudio").get && $("#waudio").get(0))
this.playingAccent = accent || 'en'
this.audio.playing = true
if (el) {
this._switchingAudio = true
try { el.pause() } catch (e) {}
el.src = english
const playPromise = el.play()
const done = () => { this._switchingAudio = false }
if (playPromise && playPromise.then) {
playPromise.then(done).catch(() => {
done()
this.playingAccent = ''
this.audio.playing = false
})
} else {
done()
}
return
}
$("#waudio").attr("src", english)
const that = this
setTimeout(function () {
const audioEl = $("#waudio").get(0)
if (!audioEl) {
that.playingAccent = ''
return
}
audioEl.play().catch(function () {
that.playingAccent = ''
that.audio.playing = false
})
}, 80)
},
playB: function (english) {
var value = english.toLowerCase();
let tts_en = "https://dict.youdao.com/dictvoice?audio=" + value + "&type=1";
this.playA(tts_en, 'en')
},
selectTest: function () {
this.$router.push({ path: '/testProject_hideTabBar' })
},
selectStudy: function () {
this.$router.push({ path: '/studyProject_hideTabBar' })
},
hideShadow: function () {

this.showDeil = false;

},

goPre: function () {
this.clearWordNavigateStack();
this.showDeil = true;
if (this.index == 0) {
this.toastText = "这是该单元的第一个单词 前面已经没有了";
this.showPositionValue = true;
return;
} else {
this.index = this.index - 1;
}
this.wordinfo = this.wordList[this.index]
this.getWordByid(this.wordinfo.id,this.wordinfo.wordId)
},
goNext: function () {
this.clearWordNavigateStack();

if (this.index >= this.wordList.length - 1) {
this.toastText = "该单元已学完";
this.showPositionValue = true;
return;
}
if (this.isWordPower==0&& this.index >=4) {
this.toastText = "未开通该书仅可体验前5个单词，请兑换激活码后学习全部内容";
this.showPositionValue = true;
return;
}
this.index++;
const currentWord = this.wordList[this.index];
this.getWordByid(currentWord.id, currentWord.wordId);





}
}
}



// WEBPACK FOOTER //
// ./src/views/word/cell/index.vue